export default __webpack_public_path__ + "static/media/description_2.cc1194b0.svg";